import Product from "../../../../../../@types/Product";

const Tops: Product[] = [
    {
        id: 1,
        name: '120″ MadJax XSeries 2 Passenger Top - Black',
        sku: '26-177-X',
        price: 0.00,
        retailPrice: 0.00,
    },
];

export default Tops;